// William & Mary's undergraduate majors (#2748). Read on 2026-10-01 from
// W&M's official Program Finder (wm.edu/academics/programs), whose program
// list is embedded in the page as data: every program marked undergraduate
// with a Bachelor's path of study is kept, one line per bachelor's degree
// (B.A., B.S., B.B.A., B.A.Ed. and B.M.A.P., as the finder abbreviates
// them). Minors, certificates and graduate paths are left out. The finder's
// "*Degree is in ..." remarks are kept as notes. W&M's online catalog
// (catalog.wm.edu) answered with an empty bot-check page to both curl and
// WebFetch, so the finder is the official list used. The Applied
// Artificial Intelligence program name, abbreviation included, is the
// finder's own. The KB's majors list was the starting point; the finder
// wins.
const majors = {
    "slug": "college-of-william-and-mary",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in W&M's official Program Finder, grouped by the school that offers it, with the degree it leads to. Where the finder says the degree is awarded in another field, the note says so. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "William & Mary Program Finder (Undergraduate, Bachelor's Degrees)",
                "url": "https://www.wm.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.M.A.P."
                },
                {
                    "name": "Art History",
                    "degree": "B.A.",
                    "note": "The degree is in Fine Arts."
                },
                {
                    "name": "Asian & Middle Eastern Studies (AMES)",
                    "degree": "B.A.",
                    "note": "The degree is in International Studies."
                },
                {
                    "name": "Asian & Pacific Islander American Studies (APIA)",
                    "degree": "B.A.",
                    "note": "The degree is in International Studies."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chinese Language & Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computational & Applied Mathematics",
                    "degree": "B.M.A.P."
                },
                {
                    "name": "Computational & Applied Mathematics & Statistics (CAMS)",
                    "degree": "B.S."
                },
                {
                    "name": "Contemplative Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Religion."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environment & Sustainability",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "Environment & Sustainability",
                    "degree": "B.S.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A.",
                    "note": "The degree is in International Studies."
                },
                {
                    "name": "Film & Media Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "French & Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality & Women's Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Government",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Health & Physiology",
                    "degree": "B.S."
                },
                {
                    "name": "Integrative Conservation",
                    "degree": "B.S.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Judaic Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Religion."
                },
                {
                    "name": "Latin American & Caribbean Studies",
                    "degree": "B.A.",
                    "note": "The degree is in International Studies."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Medieval & Renaissance Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.A."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A.",
                    "note": "The degree is in Religion."
                },
                {
                    "name": "Russian, East European & Eurasian Studies",
                    "degree": "B.A.",
                    "note": "The degree is in International Studies."
                },
                {
                    "name": "Self-Designed",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "Self-Designed",
                    "degree": "B.S.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A.",
                    "note": "The program finder lists it as \"Spanish (see also Hispanic Studies)\"."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A.",
                    "note": "The degree is in Fine Arts."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "William & Mary Program Finder (Undergraduate, Bachelor's Degrees)",
                "url": "https://www.wm.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A.",
                    "note": "The degree is in Business Administration."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.B.A.",
                    "note": "The degree is in Business Administration."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A.",
                    "note": "The degree is in Business Administration."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A.",
                    "note": "The degree is in Business Administration."
                }
            ]
        },
        {
            "name": "School of Computing, Data Sciences & Physics",
            "source": {
                "label": "William & Mary Program Finder (Undergraduate, Bachelor's Degrees)",
                "url": "https://www.wm.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Applied Artificial Intelligence (AI)",
                    "degree": "B.A.",
                    "note": "The degree is in Interdisciplinary Studies."
                },
                {
                    "name": "Bioengineering",
                    "degree": "B.A."
                },
                {
                    "name": "Bioengineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.M.A.P."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Coastal & Marine Sciences",
            "source": {
                "label": "William & Mary Program Finder (Undergraduate, Bachelor's Degrees)",
                "url": "https://www.wm.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Coastal & Marine Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "William & Mary Program Finder (Undergraduate, Bachelor's Degrees)",
                "url": "https://www.wm.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "B.A.Ed."
                }
            ]
        }
    ]
};

export default majors;
